import { SecuredStorageContext, StorageContext } from '../../contexts/storage';

export class MockStorageServiceV2 {
	private storage: Record<string, string> = {};

	async getItem(key: string): Promise<null | string> {
		return this.storage[key] ?? null;
	}

	async setItem(key: string, value: string): Promise<void> {
		this.storage[key] = value;
	}

	async removeItem(key: string): Promise<void> {
		delete this.storage[key];
	}

	async hasKey(key: string): Promise<boolean> {
		return key in this.storage;
	}

	async clear(): Promise<void> {
		this.storage = {};
	}

	async getJSON<T>(key: string): Promise<T> {
		const value = await this.getItem(key);

		return JSON.parse(value!) as T;
	}

	setJSON = async (key: string, value: unknown): Promise<void> => this.setItem(key, JSON.stringify(value));

	getBoolean = async (key: string): Promise<boolean> => (await this.getItem(key)) === 'true';

	setBoolean = async (key: string, value: boolean): Promise<void> => this.setItem(key, value ? 'true' : 'false');

	getNumber = async (key: string): Promise<number> => Number(await this.getItem(key));

	setNumber = async (key: string, value: number): Promise<void> => this.setItem(key, value.toString());
}

export function MockStorageProvider({ children }: { children: React.ReactNode }) {
	return (
		<SecuredStorageContext.Provider value={new MockStorageServiceV2()}>
			<StorageContext.Provider value={new MockStorageServiceV2()}>{children}</StorageContext.Provider>
		</SecuredStorageContext.Provider>
	);
}
